import keys from './keys';
import useApiQuery from '../useApiQuery';
import { useParams } from 'react-router-dom';

const useGetHeadlinerVideos = ({ showId: showIdParam, episodeId: episodeIdParam } = {}) => {
  const { showId: currentShowId, episodeId: currentEpisodeId } = useParams();
  const showId = showIdParam || currentShowId;
  const episodeId = episodeIdParam || currentEpisodeId;

  const query = useApiQuery({
    queryKey: keys.video({ showId, episodeId }),
    requestUrl: `/shows/${showId}/episodes/${episodeId}/promovideos`,
    disabled: !showId || !episodeId,
    refetchOnWindowFocus: true,
  });

  return {
    checkHeadlinerVideos: query.refetch,
    headlinerVideos: query.data,
    headlinerVideosError: query.error,
    isHeadlinerVideosFetchError: query.isError,
    isHeadlinerVideosFetchSuccess: query.isSuccess,
    isHeadlinerVideosFetching: query.isFetching,
    isHeadlinerVideosLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetHeadlinerVideos;
